import './App.css';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import { Provider } from 'react-redux';
import Backdrop from "@mui/material/Backdrop";
import store from './Redux/store.js';
import logo from "./Images/logo-4.png";
import ProtectedRoute from "./ProtectedRoute";
import Adminroutes from "./Adminroutes";

// Component imports
import Home from './Component/Home.jsx';
import Footer from './Component/Footer';
import Header from './Component/Navbar';
import Facility from './Component/Facility';
import Login from './Component/Login';
import ResetPassword from './Component/ResetPassword';
import Thanx from './Component/Thanx';
import About from './Component/About';
import Contact from './Component/Contact';
import Locations from './Component/Location';
import Event from './Component/Event';
import EventDetail from './Component/EventDetail';
import Membership from './Component/Membership';
import History from './Component/History';
import Management from './Component/Management';
import Affiliation from './Component/Affiliation';
import RoomBook from './Component/RoomBook';
import Terms from './Component/Terms.jsx';
import Privacypolicy from './Component/Privacypolicy.jsx';
import Gallary from './Component/Gallary.jsx';
import Memberspeak from './Component/Memberspeak.jsx';
import BookingDetail from './Component/Founder/Bookdetails.jsx';
import Booking from './Component/Founder/Booking.jsx';
import Bill from './Component/Founder/Bill.jsx';
import Takeaway from './Component/Founder/Takeaway.jsx';
import Account from './Component/Founder/Account.jsx';
import Accommodation from './Component/Accommodation.jsx';
import Jaiclublive from './Component/Jaiclublive.jsx';
import Notices from './Component/Notices.jsx';
import MessageBoard from './Component/Message.jsx';
import AdminLogin from './Component/Admin.jsx';
import CircularNotice from './Component/CircularNotice.jsx';
import Dashboard from './Component/Founder/Dashboard.jsx';
import BranchDetails from './Component/BranchDetails.jsx';
import AdminDashboard from './Component/Admin/Dashboard.jsx';
import FacilityDetails from './Component/FacilityDetails.jsx';
import PaymentConfirmation from './Component/PaymentConformation.jsx'; // ✅ corrected name
import CartPage from './Component/Founder/CartPage.jsx';
import { CartProvider } from "./Component/Founder/CartContext.jsx";
import Redirectpage from './Component/Founder/Redirectpage.jsx';
import SportsBooking from './Component/Founder/SportsBooking.jsx';
import ChildrenPrivacypolicy from './Component/ChildrenPrivacypolicy.jsx';

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const currentPath = location.pathname.toLowerCase();

  console.log(location);
  

  const hiddenPathsExact = useMemo(() => [
    '/login', '/bookdetails', '/resetpassword', '/thanx', '/test', '/dashboard/',
    '/dashboard', '/admin', '/accomodation', '/admindashboard',
    '/bill', '/takeaway', '/booking', '/dashboard/booking',
    '/dashboard/bill', '/dashboard/takeaway', '/dashboard/account', '/dashboard/sportsbooking', '/dashboard/cart', '/mob-login', '/PaymentIntegration', '/PaymetWebhook'
  ], []);

  const shouldHideNavbarFooter = useMemo(() => {
    return hiddenPathsExact.includes(currentPath) ||
      (currentPath.startsWith('/booking/') && currentPath !== '/booking');
  }, [currentPath, hiddenPathsExact]);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <Provider store={store}>
      <div className="App ">
        {!shouldHideNavbarFooter && !loading && <Header />}
        {loading ? (
          <Backdrop
            sx={{ color: "#000", bgcolor: "rgb(216, 227, 240)", zIndex: 9999 }}
            open={true}
          >
            <div className="loader">
              <img src={logo} alt='logo of website' />
            </div>
          </Backdrop>
        ) : (
          <Routes>
            {/* Main Pages */}
            <Route path="/" index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/event" element={<Event />} />
            <Route path="/eventdetail" element={<EventDetail />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/History" element={<History />} />
            <Route path="/management" element={<Management />} />
            <Route path="/affiliation" element={<Affiliation />} />
            <Route path="/gallery" element={<Gallary />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/message" element={<MessageBoard />} />

            {/* Facility Routes */}
            <Route path="/facility" element={<Facility showHedeing={true} />} />
            <Route path="/facility/:name" element={<FacilityDetails />} />
            <Route path="/facility/:name/:id" element={<BranchDetails />} />

            {/* Other Public Pages */}
            <Route path="/jaiclublive" element={<Jaiclublive />} />
            <Route path="/roombook" element={<RoomBook />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacypolicy" element={<Privacypolicy />} />
            <Route path="/child-safety-standards" element={<ChildrenPrivacypolicy />} />
            <Route path="/news" element={<CircularNotice />} />
            <Route path="/memberspeak" element={<Memberspeak />} />
            <Route path="/bookdetails" element={<BookingDetail />} />
            <Route path="/thanx" element={<Thanx />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mob-login" element={<Redirectpage />} />

            {/* Dashboard/Admin Pages */}
            <Route path="/admin" element={
              // <Adminroutes>
                <AdminLogin />
              // </Adminroutes>
            } />
            <Route path="/admindashboard" element={
              // <Adminroutes>
                <AdminDashboard />
              // </Adminroutes>
            } />

            {/* ✅ Payment Confirmation */}
            {/* <Route path="/PaymentIntegration" element={<PaymentConfirmation />} /> */}

            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/booking" element={
              <ProtectedRoute>
                <Booking showBackButton={true} />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/account" element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/bill" element={
              <ProtectedRoute>
                <Bill showBackButton={true} />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/takeaway" element={
              <ProtectedRoute>
                <Takeaway showBackButton={true} />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/cart" element={
              <CartProvider>
                <ProtectedRoute>
                  <CartPage showBackButton={true} />
                </ProtectedRoute>
              </CartProvider>
            } />

            {/* Booking Pages */}
            <Route path="/booking" element={
              <CartProvider>
                <ProtectedRoute>
                  <Booking />
                </ProtectedRoute>
              </CartProvider>
            } />
            <Route path="/booking/:type" element={
              <CartProvider>
                <ProtectedRoute>
                  <Accommodation />
                </ProtectedRoute>
              </CartProvider>
            } />
            <Route path="/booking/sports" element={
              <CartProvider>
                <ProtectedRoute>
                  <SportsBooking showBackButton={true} />
                </ProtectedRoute>
              </CartProvider>
            } />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}
        {!shouldHideNavbarFooter && !loading && <Footer />}
      </div>
    </Provider>
  );
}

export default App;
